<script lang="ts">
	import {
		Dialog,
		DialogOverlay,
		DialogTitle,
		Transition,
		TransitionChild
	} from '@rgossiaux/svelte-headlessui'
	import { Cog, Icon, X as XIcon } from 'svelte-hero-icons'

	import { goto } from '$app/navigation'
	import { clickOutside } from '$lib/components/ClickOutside/clickOutside.js'
	import AppEvent from '$lib/components/Events/Event.svelte'
	import ListEmpty from '$lib/components/Events/list_empty.svelte'
	import InfiniteScroll from '$lib/components/misc/infinite_scroll.svelte'
	import viewport from '$lib/components/misc/viewport_action'
	import { messages } from '$lib/messages'
	import { apiGetJson, apiPostJson } from '$lib/proxy/apiProxy'
	import { fetchAccountEventsNews } from '$lib/stores/account_events_types'

	export let visible = true

	const len = '10'
	let pathOrigin = '/events/infinite'

	let title = 'Notifications'
	let topFilterts = true
	let state = ''
	let events: any[] = []
	let path = '/events/infinite'
	let params: { [name: string]: string } = { state, len }
	let resetInifinite = true
	let initialized = false

	const classTabSelected = 'border-blue-600 text-blue-500'
	const classTabUnselected =
		'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 '

	$: classTabAll = state === 'all' ? classTabSelected : classTabUnselected
	$: classTabUnread = state === 'unread' ? classTabSelected : classTabUnselected
	$: classTabWarning = state === 'warning' ? classTabSelected : classTabUnselected

	$: loadData = visible

	$: {
		if (loadData) initFilter('all')
		else {
			events = []
			initialized = false
			state = ''
		}
	}

	async function getEvents() {
		// GET {{baseUrl}}/events/infinite?len=3
		const jsonData = await apiGetJson(path, params)
		if(!jsonData || jsonData?.error){
			parseNextUrl('')
		} else {
			parseNextUrl(jsonData.next_url)
		}

		events = [...events, ...jsonData.events]
	}

	const closeDialog = () => (visible = false)

	const goSettings = () => {
		//goto('/settings?anchor=notifications')
		goto('/settings/notifications')
		// required if already on the same page
		closeDialog()
	}

	const handleSetFilter = async (event: Event, s: string) => {
		event.stopImmediatePropagation()
		event.preventDefault()
		event.stopPropagation()
		initFilter(s)
	}

	const initFilter = async (s: string) => {
		if (state === s) return // only if change tab

		initialized = false

		// restore data
		path = pathOrigin
		params = { state: s, len }
		events = []
		resetInifinite = true

		state = s
		await getEvents()
		initialized = true
	}

	const parseNextUrl = (next: string) => {
		// there is no data
		if (next === '') {
			path = ''
			params = {}
			return
		}

		// split nextUrl
		let nextSplit = next.split('?')
		let u = nextSplit[1] // get parameters (?...)

		let p: { [name: string]: string } = {}

		// parse querystring
		const urlParams = new URLSearchParams(u)
		urlParams.forEach((v, k) => (p[k] = v)) // convert to object

		params = p
	}

	const handleLoadMore = async () => {
		if (initialized) await getEvents()
	}

	const handleDismissEvent = async (id: string) => {
		console.log('handleDismissEvent')
		try {
			await apiPostJson('/events/state', { id: id, state: 'archived' })
			fetchAccountEventsNews()
			events = events.filter((e) => e.id !== id)
		} catch (err) {
			messages.error("can't archive event")
		}

	}

	const handleGoSettings = async () => {
		// console.log('handleGoSettings')
		goSettings()
	}

	const handleCloseEvents = async () => {
		// console.log('handleCloseEvents')
		closeDialog()
	}

	const handleViewEvent = async (event: any) => {
		if (event.state === 'viewed') return

		try {
			await apiPostJson('/events/state', { id: event.id, state: 'viewed' })
			fetchAccountEventsNews()
			//			events = events.filter( e => e.id !== id )
		} catch (err) {
			messages.error("can't archive event")
		}
	}

	function handleToggleOffEventList() {
		closeDialog()
	}
</script>

<Transition show={visible}>
	<Dialog
		open={visible}
		class="fixed inset-0 overflow-hidden z-10"
		aria-labelledby="slide-over-title"
		role="dialog"
		aria-modal="true"
	>
		<TransitionChild
			enter="ease-in-out duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="ease-in-out duration-500"
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			<DialogOverlay
				class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
				aria-hidden="true"
			/>
		</TransitionChild>

		<!-- id=globalEventList is used as main-clickoutside in elements that prevent close -->
		<div
			class="fixed inset-y-0 right-0 max-w-full flex"
			id="globalEventList"
			use:clickOutside
			on:click_outside={handleToggleOffEventList}
		>
			<!-- Slide-over panel, show/hide based on slide-over state. -->
			<TransitionChild
				enter="transform transition ease-in-out duration-500 sm:duration-700"
				enterFrom="translate-x-full"
				enterTo="translate-x-0"
				leave="transform transition ease-in-out duration-500 sm:duration-700"
				leaveFrom="translate-x-0"
				leaveTo="translate-x-full"
			>
				<div class="relative w-screen max-w-full sm:max-w-md h-full">
					<!-- <div class="h-full flex flex-col bg-white shadow-xl overflow-y-scroll"> -->
					<div class="h-full flex flex-col bg-white">
						<div class="p-6">
							<div class="flex items-start justify-between">
								<DialogTitle
									as="h2"
									class="text-lg font-medium text-gray-900"
									id="slide-over-title"
								>
									{title}
									<button
										class="text-gray-400 hover:text-gray-500 align-bottom"
										on:click={goSettings}
									>
										<Icon src={Cog} class="h-6 w-6" />
									</button>
								</DialogTitle>
								<div class="ml-3 flex h-7 items-center">
									<button
										type="button"
										class="rounded-md text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
									>
										<span class="sr-only">Close panel</span>
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<div on:click={closeDialog}>
											<Icon src={XIcon} class="h-6 w-6" />
										</div>
									</button>
								</div>
							</div>
						</div>
						<!-- <div class="mt-6 relative flex-1 px-4 sm:px-6"> -->
						<!-- Replace with your content -->
						{#if topFilterts}
							<div class="border-b border-gray-200">
								<div class="px-6">
									<nav class="-mb-px flex space-x-6">
										<!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
										<a
											href={null}
											on:click|preventDefault|stopPropagation|preventDefault={(e) =>
												handleSetFilter(e, 'all')}
											class="${classTabAll} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
											>All</a
										>
										<a
											href={null}
											on:click|preventDefault|stopPropagation|preventDefault={(e) =>
												handleSetFilter(e, 'unread')}
											class="${classTabUnread} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
											>Unread</a
										>
										<a
											href={null}
											on:click|preventDefault|stopPropagation|preventDefault={(e) =>
												handleSetFilter(e, 'warning')}
											class="${classTabWarning} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
											>Warnings</a
										>
									</nav>
								</div>
							</div>
						{/if}

						<!-- <ul role="list" class="flex-1 divide-y divide-gray-200 overflow-y-auto"> -->
						<!-- <div class="h-full flex flex-col shadow-xl overflow-y-scroll"> -->

							{#if events && events.length > 0}
								<ul class="flex-1 overflow-y-auto">
									{#each events as event, i}
										{#if event.state !== 'archived'}
											<li>
												<AppEvent
													{event}
													on:event_dismiss={() => handleDismissEvent(event.id)}
													on:events_close={() => handleCloseEvents()}
												/>
											</li>
											<hr
												class="solid mx-2"
												use:viewport
												on:enterViewport={() => handleViewEvent(event)}
											/>
											<!--on:exitViewport={() => console.log('exit!')}-->
										{/if}
									{/each}
									<InfiniteScroll
										hasMore={path !== ''}
										threshold={100}
										on:loadMore={async () => await handleLoadMore()}
										bind:reset={resetInifinite}
									/>
								</ul>
							{:else if initialized}
								<ListEmpty on:go_Settings={() => handleGoSettings()} />
							{/if}
						<!-- </div> -->
					</div>
				</div>
			</TransitionChild>
		</div>
	</Dialog>
</Transition>
